import classNames from "classnames";
import Markdown from "components/markdown/markdown";
import { TeamMemberCard } from "./teamMemberCard";

export default function ContactAndTeam({ data }) {
  return (
    <div>
      <div
        className={classNames(
          "mb-5 mt-[70px] flex flex-col lg:mb-[40px] lg:mt-0 lg:flex-row lg:gap-x-[60px]",
          "[&_a]:inline [&_a]:text-cerise [&_a]:underline [&_a]:[text-underline-position:under]",
          "focus:[&_a]:outline-none focus-visible:[&_a]:outline-none focus-visible:[&_a]:ring",
          "focus-visible:[&_a]:ring-cerise"
        )}
      >
        {data.newsTeamContactText && (
          <Markdown
            className="mb-5 font-recklessBold text-[32px] leading-[42px] lg:mb-0 lg:min-w-[350px]"
            text={data.newsTeamContactText}
          />
        )}
        {data.newsTeamSectionContact && (
          <Markdown
            className="font-serif text-[14px] leading-[18px] text-mono-40 lg:self-center"
            text={data.newsTeamSectionContact}
          />
        )}
      </div>

      <div className="mb-[100px] grid grid-cols-1 gap-x-10 gap-y-[30px] md:grid-cols-2 lg:mb-[70px]">
        {data.teamMembers.length &&
          data.teamMembers.map((member, i) => {
            return <TeamMemberCard key={i} member={member} />;
          })}
      </div>
    </div>
  );
}
